import { ComponentSingleStyleConfig } from "@chakra-ui/react";

export const tooltipTheme: ComponentSingleStyleConfig = {
  baseStyle: {
    backgroundColor: "white",

    // there is a known bug that prevents the backgroundColor being
    // applied to the pointer arrow/ diamond
    // https://github.com/chakra-ui/chakra-ui/issues/4695
    "--popper-arrow-bg": "white",
    "--popper-arrow-shadow-color": "var(--chakra-colors-gray-200)",

    color: "gray.800",
    borderWidth: "1px",
    borderColor: "gray.300",
    borderRadius: "md",
    boxShadow: "md",
    px: 3,
    py: 2,
  },
};
